import React from 'react';
import { Edit } from 'lucide-react';
import Button from '../../../components/ui/Button';

const DealInformationCard = ({ dealData, onEdit }) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      {/* Card Header */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-lg font-semibold text-gray-900">
          Deal Information
        </h2>
        <Button
          onClick={onEdit}
          variant="ghost"
          size="sm"
          className="text-gray-500 hover:text-gray-700 p-2"
        >
          <Edit className="h-4 w-4" />
        </Button>
      </div>

      {/* Deal Details */}
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <p className="text-sm font-medium text-gray-500 mb-1">
              Deal/Fund Name
            </p>
            <p className="text-gray-900 font-medium">
              {dealData?.dealName}
            </p>
          </div>

          <div>
            <p className="text-sm font-medium text-gray-500 mb-1">
              Asset Type
            </p>
            <p className="text-gray-900 font-medium">
              {dealData?.assetType}
            </p>
          </div>

          <div>
            <p className="text-sm font-medium text-gray-500 mb-1">
              Deal/Fund Structure
            </p>
            <p className="text-gray-900 font-medium">
              {dealData?.dealStructure}
            </p>
          </div>
        </div>

        <div>
          <p className="text-sm font-medium text-gray-500 mb-2">
            Brief Description
          </p>
          <p className="text-gray-700 text-sm leading-relaxed">
            {dealData?.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default DealInformationCard;